import React, { useEffect, useState } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { getSessionFromCookie } from './utils/cognito.ts';
import Loading from './ui/Loading.tsx';





const ProtectedRoute: React.FC = () => {
  const [isSessionChecked, setIsSessionChecked] = useState(false);
  const [isSessionValid, setIsSessionValid] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const session = getSessionFromCookie();
    setIsSessionValid(!!session);
    setIsSessionChecked(true);

    const ref = searchParams.get('ref');

    if (!session) {
      const baseLoginUrl = window.location.hostname.includes('localhost')
        ? 'http://localhost:3000'
        : import.meta.env.VITE_LOGIN;

      let finalLoginUrl = baseLoginUrl;
      try {
        const url = new URL(baseLoginUrl, window.location.origin);
        if (ref) url.searchParams.set('ref', ref); 
        finalLoginUrl = url.toString();
      } catch {
        if (ref) {
          const sep = baseLoginUrl.includes('?') ? '&' : '?';
          finalLoginUrl = `${baseLoginUrl}${sep}ref=${encodeURIComponent(ref)}`;
        }
      }

      window.location.href = finalLoginUrl;
    }

  }, []);

  if (!isSessionChecked) {
    return <Loading />;
  }

  return isSessionValid ? <Outlet /> : null;
};

export default ProtectedRoute;
